import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UnauthorizedLayoutComponent } from './layout/unauthorized-layout/unauthorized-layout.component';
import { AuthorizedLayoutComponent } from './layout/authorized-layout/authorized-layout.component';
import {
  LayoutService,
  PageLayout as PageLayoutEnum,
} from './layout/layout.service';
import { AsyncPipe } from '@angular/common';
import { lastValueFrom } from 'rxjs';
import { TextFieldModule } from '@angular/cdk/text-field';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    UnauthorizedLayoutComponent,
    AuthorizedLayoutComponent,
    AsyncPipe,
    TextFieldModule,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  // changeDetection: ChangeDetectionStrategy.Default,
})
export class App {
  protected title = 'beizy';

  PageLayout = PageLayoutEnum;

  settedLayout = PageLayoutEnum.Error;

  constructor(
    public layoutService: LayoutService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    // Initialize the layout service with the default layout
    // this.layoutService.setLayout(PageLayoutEnum.UnAuthorized);
    this.check(); // Call the check method to set the layout
  }

  onInit() {
    this.check(); // Call the check method to set the layout
  }

  check() {
    // This method can be used for any initialization logic if needed
    this.layoutService.layout$ // Use lastValueFrom to get the latest value from the observable

      .subscribe((layout) => {
        console.log('Current layout:', layout);
        this.settedLayout = layout;
      });
    // .catch((error) => {
    //   console.error('Error fetching layout:', error);
    // })
    // .finally(() => {
    //   this.changeDetectorRef.markForCheck(); // Ensure change detection is triggered
    // });
  }
}
